import { render, staticRenderFns } from "./TextHref.vue?vue&type=template&id=96ad1b3a"
import script from "./TextHref.vue?vue&type=script&lang=js"
export * from "./TextHref.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports